import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import logo from "Resources/Images/logo_46_37.jpg";
import logo1 from "Resources/Images/logont_68_37.jpg";
import "Resources/Css/bootstrap.min.css";
import "Resources/Css/StyleSheet.css";
import "Resources/Css/css.css";
import "Resources/Css/cssNew.css";
import "Resources/Css/MaterialDesign-Webfont-master/css/materialdesignicons.min.css";
import "Resources/Css/css1.css";
import "react-widgets/dist/css/react-widgets.css";

import Autocomplete from "react-autocomplete";
import axios from "axios";
import Config from "constants/configs";
import {
  getUserLogin,
  getBranch,
  getUrl,
  getDomain,
  timeFromNow,
} from "utils/utils";
import Cookies from "universal-cookie";

import support from "Resources/ImagesNew/iconSupport.png";
import Help from "Resources/ImagesNew/iconHelp.png";
import facebook from "Resources/ImagesNew/facebookIcon.png";
import zalo from "Resources/ImagesNew/zaloIcon.png";
import phone from "Resources/ImagesNew/iconPhone.png";
import iconsearch from "Resources/ImagesNew/icon_search.png";
import iconclose from "Resources/ImagesNew/icon_close.png";
import loadding from "Resources/ImagesNew/Loading_2.gif";
import nodata from "Resources/ImagesNew/nodata.png";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
import { pushNotification } from "utils/notifications";

import UserApi from "service/User/UserApi";
import DanhMucApi from "service/danhmucApi";
import configs from "constants/configs";
import { size } from "lodash";
import iconThongBao from "Resources/ImagesNew/mi_notification.png";
import iconHDSD from "Resources/ImagesNew/huongDan.png";
import iconTicket from "Resources/ImagesNew/icon _receipt_.png";
import iconHotLine from "Resources/ImagesNew/hotLine.png";
import iconThongBaoHover from "Resources/ImagesNew/mi_notificationHover.png";
import iconHDSDHover from "Resources/ImagesNew/huongDanHover.png";
import iconTicketHover from "Resources/ImagesNew/icon _receipt_Hover.png";
import iconHotLineHover from "Resources/ImagesNew/hotLineHover.png";
import { ModalDanhGia } from "./ModalDanhGia";
import InfiniteScroll from "react-infinite-scroll-component";

class HeaderNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      objChiNhanh: "",
      iBranch: getBranch(),
      objUser: getUserLogin(),
      urlAPI: getDomain(),
      NameLink: "",
      showNotiDHQuaHan: null,
      iCountQuaHan: 0,
      showXacThucDangNhap: 0,
      countXacThucDangNhap: 0,
      isShowXacThuc: false,
      sSearchChucNangTimKiem: "",
      lstChucNangTimKiemHeader: {
        List: [],
      },
      lstChucNangTimKiemHeaderAll: {
        List: [],
      },
      dataThongBao: [],
      isShowHotline: false,
      isShowTicket: false,
      iCountTicket: 0,
      listTicket: [],
      redirect: false,
      dataDetail: {},
      isModalVisible: false,
      TieuDeTicket: "",
      TenTrangThaiTicket: "",
      idTicket: 0,
      TotalRowAllTicket: 0,
      hasMore: true,
      pageTicket: 1,
      widthdropdownheader: 0,
      leftdropdownheader: 0,
      intervalHeaderTimKiem: 0,
      showNotification: false,
      isShowNotification: false,
      countNotification: 0,
      dataNotification: [],
      pageNotification: 1,
      hasMoreNoti: true,
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleClickOutsideTicket = this.handleClickOutsideTicket.bind(this);
    this.handleClickOutsideNoti = this.handleClickOutsideNoti.bind(this);
  }

  toggleShowHotline() {
    this.setState({ isShowHotline: !this.state.isShowHotline });
  }

  componentDidMount() {
    const currentUrl = window.location.pathname;
    if (currentUrl.includes("/DangNhap")) {
      return;
    }

    const cookies = new Cookies();
    var userToken = cookies.get("userTokenDaiLy");
    if (userToken === "" || typeof userToken === "undefined") {
      window.location.href = "/DangNhap";
    }

    const dataSearch = {
      ngay: moment().format("YYYY-MM-DD"),
      branchId: getBranch(),
    };
    DanhMucApi.getAllConfigSTKey().then((response) => {
      if (
        response.data.List.length > 0 &&
        this.state.showNotiDHQuaHan == null
      ) {
        const isShowNotiQuaHan = response.data.List.find(
          (e) =>
            e.KeyID.toUpperCase() === configs.sKey.isShowDHQuaHan.toUpperCase(),
        );
        this.state.showNotiDHQuaHan = false;
        if (isShowNotiQuaHan != null) {
          if (isShowNotiQuaHan.Value === "1") {
            this.setState({ showNotiDHQuaHan: true });
          }
        }
      }
    });

    const url = window.location.pathname;
    // if(url.toLocaleLowerCase().includes('trangchu') || url.toLocaleLowerCase().includes('neworder4'))
    //   {
    //     UserApi.GetRoleHeader(
    //       getUserLogin().UserName,
    //       this.state.sSearchChucNangTimKiem,
    //       getBranch()
    //     ).then((response) => {
    //       if (response.status == 200) {
    //         let state = this.state;
    //         state.lstChucNangTimKiemHeader.List = response.data;
    //         state.lstChucNangTimKiemHeaderAll.List = response.data;
    //         this.setState(state);
    //       }
    //     });
    //   }

    // if (this.props.isBranch !== false) {
    //   axios
    //     .get(
    //       this.state.urlAPI +
    //       "chinhanh/listChiNhanh?sUserName=" +
    //       this.state.objUser.UserName,
    //       {
    //         headers: {
    //           Authorization: userToken.substring(6)
    //         }
    //       }
    //     )
    //     .then((d) => {
    //       const cookies = new Cookies();
    //       var chinhanh = cookies.get("ChiNhanh");
    //       if (typeof chinhanh === "undefined" || chinhanh === "") {
    //         cookies.set("ChiNhanh", d.data.List[0].BranchID, { path: "/" });
    //       }
    //       let state = this.state;
    //       state.objChiNhanh = d.data;
    //       if (this.props.isNotBranchTong) {
    //         var lst = d.data.List.filter((x) => x.BranchID !== 0);
    //         cookies.set("ChiNhanh", lst[0].BranchID, { path: "/" });
    //         state.iBranch = lst[0].BranchID;
    //         window.location.reload(false);
    //       }
    //       if (this.props.isCheckBranch) {
    //         var lstNew = d.data.List.filter(
    //           (x) => x.BranchName === this.props.isCheckBranch
    //         );
    //         cookies.set("ChiNhanh", lstNew[0].BranchID, { path: "/" });
    //         state.iBranch = lstNew[0].BranchID;
    //       }

    //       this.setState({ state });
    //     })
    //     .catch((err) => {
    //       console.log(err.data);
    //     });
    // }

    // BanHangApi.getFullRole(getUserLogin().UserName).then((roleDetail) => {
    //   if (roleDetail.status === 200) {
    //     if (roleDetail.data.List.length > 0) {
    //       var sRoleBanHang = roleDetail.data.List.find(
    //         (e) => e.toUpperCase() === configs.sRole.HT_THONGBAO.toUpperCase()
    //       );
    //       if (sRoleBanHang != null) {
    //         this.setState({ showNotification: true });
    //         this.onLoadCountNotification();
    //       }
    //     }
    //   }
    // });

    //api chi tiết hướng dẫn sử dụng
    // axios
    //   .get(
    //     this.state.urlAPI +
    //       "HDSD/GetListHDSD_byLink?Link=" +
    //       window.location.pathname
    //   )
    //   .then((d) => {
    //     if (d.data !== null) {
    //       let state = this.state;
    //       state.NameLink = d.data.Name;
    //       this.setState({ state });
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err.data);
    //   });
    //api chi tiết hướng dẫn sử dụng
    document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("mousedown", this.handleClickOutsideTicket);
    document.addEventListener("mousedown", this.handleClickOutsideNoti);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.removeEventListener("mousedown", this.handleClickOutsideTicket);
    document.removeEventListener("mousedown", this.handleClickOutsideNoti);
  }
  renderSelectChiNhanh() {
    let objChiNhanh = this.state.objChiNhanh;
    if (typeof objChiNhanh.List != "undefined") {
      return objChiNhanh.List.map((chinhanh, index) => {
        const { BranchName, BranchID } = chinhanh;
        return <option value={BranchID}>{BranchName}</option>;
      });
    }
  }

  onShowXacThuc() {
    this.setState({ isShowXacThuc: true });
    this.onLoadThongBao();
  }
  onHideXacThuc() {
    this.setState({ isShowXacThuc: false });
  }

  onShowTicket() {
    this.setState({ isShowTicket: true });
    this.onLoadThongBao();
  }
  onHideTicket() {
    this.setState({ isShowTicket: false });
  }

  onShowNotification() {
    this.setState({ isShowNotification: true });
    this.onLoadNotification();
  }

  onHideNotification() {
    this.setState({ isShowNotification: false });
  }

  chonChucNangTimKiem(item, value) {
    if (item.IsAsp) {
      window.location.href = getUrl() + item.Link;
    } else {
      window.location.href = item.Link;
    }
  }
  cssThanhTimKiem(txt) {
    const element = document.getElementById("divSearchHeader");
    var disAb = document.querySelector("div#divSearchHeader div div");
    var disAbautolist = document.querySelectorAll(
      "div#divSearchHeader div div div.divlistouto",
    );
    var txtChucNangTimKiemHeader = txt;
    var i;
    for (i = 0; i < disAbautolist.length; ++i) {
      var item = disAbautolist[i];
      var text = item.textContent;
      let ghichu = "";
      var itemhientai = this.state.lstChucNangTimKiemHeader.List.find(
        (x) => x.Name == text,
      );
      if (itemhientai && itemhientai.GhiChu != null) {
        ghichu = itemhientai.GhiChu;
      }
      if (text.includes("PhanHe-PhanHe")) {
        var arr = text.split("PhanHe-PhanHe");
        let txtArr0 = arr[0];
        if (txtChucNangTimKiemHeader) {
          txtArr0 = arr[0]
            .toLowerCase()
            .replaceAll(
              txtChucNangTimKiemHeader.toLowerCase(),
              "<strong> " +
                txtChucNangTimKiemHeader.charAt(0).toUpperCase() +
                txtChucNangTimKiemHeader.slice(1) +
                "</strong>",
            );
        }
        txtArr0 = txtArr0.charAt(0).toUpperCase() + txtArr0.slice(1);
        if (arr[1].trim()) {
          item.innerHTML =
            " <div class='classheadernhe'> <div class='headertimkiempoint'> </div> <div class='headertimkiemcot1'>" +
            txtArr0 +
            " </div>  <div class='headertimkiemcot2'> " +
            arr[1].trim() +
            " </div> </div>" +
            ghichu;
        } else {
          item.innerHTML =
            " <div class='classheadernhe'> <div class='headertimkiempoint'> </div> <div class='headertimkiemcot1'>" +
            txtArr0 +
            " </div> </div>" +
            ghichu;
        }
      }
    }
    if (disAb) {
      if (
        !disAb.className.includes(
          "txtChucNangTimKiemHeaderAutoCompleteEx_completionListElem",
        )
      ) {
        disAb.className =
          disAb.className +
          " txtChucNangTimKiemHeaderAutoCompleteEx_completionListElem ";
      }
      if (this.state.widthdropdownheader != 0) {
        disAb.style.width = this.state.widthdropdownheader + "px";
        disAb.style.left = this.state.leftdropdownheader + "px";
      } else {
        disAb.style.width = disAb.clientWidth + 95 + "px";
        disAb.style.left = disAb.clientLeft - 10 + "px";
        let state = this.state;
        state.widthdropdownheader = disAb.clientWidth;
        state.leftdropdownheader = disAb.clientLeft;
        this.setState(state);
      }
    }
  }
  xoasSearchChucNangTimKiem() {
    let state = this.state;
    state.sSearchChucNangTimKiem = "";
    this.setState(state);
  }
  focusThanhTimKiem() {
    const newIntervalId = setInterval(() => {
      this.cssThanhTimKiem(this.state.sSearchChucNangTimKiem);
    }, 100);

    this.setState((prevState) => {
      return {
        ...prevState,
        intervalHeaderTimKiem: newIntervalId,
      };
    });
  }

  unfocusThanhTimKiem() {
    if (this.state.intervalHeaderTimKiem) {
      clearInterval(this.state.intervalHeaderTimKiem);
      this.setState((prevState) => {
        return {
          ...prevState,
          intervalHeaderTimKiem: 0,
        };
      });
      return;
    }
  }
  onChangeText(field, status, event) {
    let state = this.state;
    let value = event.target.value;
    state[field] = value;

    var BienDiem = 0;
    for (var i = 1; i < 99999; i++) {
      window.clearInterval(i);
    }
    const interval = setInterval(() => {
      BienDiem++;
      if (BienDiem == 2) {
        UserApi.GetRoleHeader(getUserLogin().UserName, value, getBranch()).then(
          (response) => {
            if (response.status == 200) {
              let state = this.state;
              state.lstChucNangTimKiemHeader.List = response.data;
              state.lstChucNangTimKiemHeaderAll.List = response.data;
              this.setState(state);
              this.focusThanhTimKiem();
            }
          },
        );
      }
    }, 500);

    let list = state.lstChucNangTimKiemHeaderAll.List.filter((x) => {
      let code = x.Code.toLowerCase();
      let name = x.Name.toLowerCase();
      if (
        code.includes(value.trim().toLowerCase()) ||
        name.includes(value.trim().toLowerCase())
      ) {
        return x;
      }
    });
    state.lstChucNangTimKiemHeader.List = list;
    this.setState(state);
    this.focusThanhTimKiem();
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.onHideXacThuc();
      this.setState({ isShowHotline: false });
    }
  }

  handleClickOutsideTicket(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.onHideTicket();
      this.setState({ isShowHotline: false });
    }
  }

  handleClickOutsideNoti(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.onHideNotification();
      this.setState({ isShowHotline: false });
    }
  }

  onLoadNotification(isScroll) {
    // debugger;
    if (isScroll) {
      this.setState({
        pageNotification: this.state.pageNotification + 1,
      });
    } else {
      this.setState({
        pageNotification: 1,
      });
    }
  }

  render() {
    console.log(this.props.isCheckBranch, "isCheckBranch");
    return (
      <>
        <div className="left-header-new header-ver2">
          <div className="searchNew">
            <div className="form-search-new">
              <div
                class="input-group"
                tabindex="0"
                id="divSearchHeader"
                onFocus={this.focusThanhTimKiem.bind(this)}
                onBlur={this.unfocusThanhTimKiem.bind(this)}
              >
                <div class="input-group-prepend">
                  <button
                    id="button-addon2"
                    type="submit"
                    class="btn btn-link text-warning"
                  >
                    <img src={iconsearch} class="" alt=""></img>
                  </button>
                </div>

                <Autocomplete
                  ref="sSearch"
                  wrapperProps={{}}
                  wrapperStyle={{ flex: "auto" }}
                  inputProps={{
                    className:
                      "form-control border-0 bg-light timkiemheaderreact",
                    readOnly: false,
                    placeholder: "Tìm kiếm chức năng...",
                  }}
                  menuStyle={{
                    borderRadius: "3px",
                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                    background: "rgba(255, 255, 255, 0.9)",
                    padding: "5px 0px",
                    fontSize: "100%",
                    position: "absolute",
                    overflow: "auto",
                    maxHeight: "250px",
                    lineHeight: "30px",
                    top: "0 !important",
                    left: "0 !important",
                    zIndex: "1000",
                  }}
                  getItemValue={(item) => item.Name}
                  items={this.state.lstChucNangTimKiemHeader.List}
                  renderItem={(item, isHighlighted) => {
                    var clss = isHighlighted
                      ? "auto-list divlistoutoLight divlistouto"
                      : "auto-list divlistouto";
                    return (
                      <div
                        className={clss}
                        style={{
                          background: isHighlighted ? "#2a6496" : "white",
                          color: isHighlighted ? "white" : "black",
                          textTransform: "capitalize",
                        }}
                      >
                        {item.Name}
                      </div>
                    );
                  }}
                  value={this.state.sSearchChucNangTimKiem}
                  onSelect={(value, item) => {
                    this.chonChucNangTimKiem(item, value);
                  }}
                  onChange={this.onChangeText.bind(
                    this,
                    "sSearchChucNangTimKiem",
                    1,
                  )}
                />
                <div class="input-group-prepend">
                  <button
                    id="button-addon4"
                    type="submit"
                    class="btn"
                    onClick={this.xoasSearchChucNangTimKiem.bind(this)}
                    style={{
                      background: "white",
                    }}
                  >
                    {this.state.sSearchChucNangTimKiem ? "xóa" : ""}
                  </button>
                </div>

                <div class="input-group-prepend">
                  <button
                    id="button-addon3"
                    type="submit"
                    onClick={this.xoasSearchChucNangTimKiem.bind(this)}
                    class="btn btn-link text-warning"
                  >
                    <img src={iconclose} class="" alt="" height="16"></img>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="header-part-right">
            <div className="nav-item-new line-header-new">
              <a
                href="#"
                alt=""
                style={{ marginLeft: "3px" }}
                // onClick={() => window.open("/Ticket/DanhSach", "_blank")}
                onClick={() => this.toggleShowHotline()}
              >
                {/* <Icon
                path={mdiAccountQuestion}
                title="Cần hỗ trợ?"
                size={1.4}
                color="#02499b"
              /> */}
                <img src={iconHotLine} alt="" title="Hotlines" />
                <img
                  src={iconHotLineHover}
                  alt=""
                  title="Hotlines"
                  className="img-top"
                />
              </a>
              {/* <a
                href="#"
                alt=""
                style={{ marginLeft: "3px" }}
                onClick={() => this.onShowTicket()}
              >
                <img src={iconTicket} alt="" title="Cần hỗ trợ?" />
                <img
                  src={iconTicketHover}
                  alt=""
                  title="Cần hỗ trợ?"
                  className="img-top"
                />
                <span class="thongbaoicon">{this.state.iCountTicket}</span>
              </a> */}

              {/* <a
                href="#"
                alt=""
                style={{ marginLeft: "3px" }}
                onClick={() =>
                  window.open("/HeThong/Help?Link=" + window.location.pathname)
                }
              >
                <img src={iconHDSD} alt="" title="Hướng dẫn sử dụng" />
                <img
                  src={iconHDSDHover}
                  alt=""
                  title="Hướng dẫn sử dụng"
                  className="img-top"
                />
              </a> */}

              {/* {(this.state.showXacThucDangNhap === 1 ||
                this.state.showNotification) && (
                  <a
                    href={() => false}
                    // style={{ marginLeft: "3px" }}
                    onClick={() => this.onShowNotification()}
                  >
                    <img src={iconThongBao} alt="" title="Thông báo" />
                    <img
                      src={iconThongBaoHover}
                      alt=""
                      title="Thông báo"
                      className="img-top"
                    />
                    <span class="thongbaoicon">
                      {this.state.countNotification +
                        this.state.countXacThucDangNhap}
                    </span>
                  </a>
                )} */}

              {/* {this.state.objChiNhanh.List &&
                this.state.objChiNhanh.List.length > 1 && (
                  <>
                    <div className="store-new">
                      <select
                        disabled={this.props.isDisable}
                        class="form-control selectCss select-new"
                        onChange={this.onChangeChiNhanh.bind(this, "iBranch")}
                        value={this.state.iBranch}
                      >
                        {this.state.objChiNhanh.List.map((chinhanh, index) => {
                          return (
                            <option value={chinhanh.BranchID}>
                              {chinhanh.BranchName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </>
                )} */}
            </div>
          </div>
        </div>

        {/* {this.state.isShowXacThuc == true && (
          <div id="divThongBao" class="divThongBao" ref={this.setWrapperRef}>
            {this.state.dataThongBao.length > 0 ? (
              <div
                class="col-md-12"
                style={{ maxHeight: "500px", overflow: "auto" }}
              >
                {this.state.dataThongBao &&
                  this.state.dataThongBao.map((item, index) => {
                    return (
                      <>
                        <div style={{ padding: "0px" }}>
                          <div style={{ fontSize: "14px", marginTop: "10px" }}>
                            Mã xác thực đăng nhập của tài khoản{" "}
                            <b>{item.UserName}</b> truy cập với IP:{" "}
                            <b>{item.IP}</b>
                          </div>
                          <div
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              color: "#02499b",
                              fontWeight: "bold",
                            }}
                          >
                            {item.Code}
                          </div>
                          <div
                            style={{
                              textAlign: "right",
                              paddingBottom: "10px",
                            }}
                          >
                            <a
                              href="#"
                              onClick={() => this.onLuuDiaChiIP(item.ID)}
                            >
                              Lưu địa chỉ IP
                            </a>
                            &nbsp;&nbsp;|&nbsp;&nbsp;
                            <a href="#" onClick={() => this.onHuyIp(item.ID)}>
                              Hủy
                            </a>
                          </div>
                        </div>
                        <div class="col-md-12" style={{ padding: "0px" }}>
                          <div
                            style={{
                              height: "1px",
                              backgroundColor: "#b1b1b1",
                            }}
                          ></div>
                        </div>
                      </>
                    );
                  })}
              </div>
            ) : (
              <div id="divNoDataThongbao" style={{ textAlign: "center" }}>
                <img src={nodata} style={{ width: "150px" }} />
                <br />
                <b style={{ fontSize: "13px", color: "#CCCCCC" }}>
                  Không có dữ liệu
                </b>
              </div>
            )}
          </div>
        )} */}

        {this.state.isShowNotification == true && (
          <div id="divThongBao" class="divThongBao" ref={this.setWrapperRef}>
            {this.state.dataNotification.length > 0 ? (
              <>
                {/* <div class="text-right" style={{ margin: "0 15px 5px" }}>
                  <a href="#" onClick={() => {}}>
                    Đọc tất cả
                  </a>
                </div> */}
                <div
                  className=""
                  id="scrollableDivNoti"
                  style={{
                    maxWidth: "500px",
                    maxHeight: "485px",
                    overflowY: "auto",
                  }}
                >
                  <InfiniteScroll
                    dataLength={this.state.dataNotification.length}
                    next={this.onLoadNotification.bind(this, true)}
                    hasMore={this.state.pageNotification}
                    loader={
                      <h4 className="text-load">
                        {this.state.dataNotification.length === 0
                          ? "Yay! Bạn đã đọc hết thông báo"
                          : "Đang tải dữ liệu..."}
                      </h4>
                    }
                    scrollableTarget="scrollableDivNoti"
                  >
                    {this.state.dataNotification &&
                      this.state.dataNotification.map((item, index) => {
                        return (
                          <div>
                            <div
                              class="col-md-12"
                              style={{
                                maxHeight: "500px",
                                overflow: "auto",
                                // backgroundColor: "#b2abab33",
                                padding: 0,
                                borderRadius: "5px",
                                margin: "10px 0",
                              }}
                            >
                              <div style={{ padding: "5px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <span
                                    className="one-line-w350"
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    {item.Title}
                                  </span>
                                  <small>{timeFromNow(item.CreatedTime)}</small>
                                </div>
                                <div
                                  className="multi-line"
                                  style={{ fontSize: "14px" }}
                                >
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.Message,
                                    }}
                                  />
                                </div>
                                {item.Type == "XTDL" && (
                                  <div
                                    style={{
                                      textAlign: "right",
                                      paddingTop: "10px",
                                    }}
                                  >
                                    <a
                                      href="#"
                                      onClick={() =>
                                        this.onLuuDiaChiIP(item.Id)
                                      }
                                    >
                                      Lưu địa chỉ IP
                                    </a>
                                    &nbsp;&nbsp;|&nbsp;&nbsp;
                                    <a
                                      href="#"
                                      onClick={() => this.onHuyIp(item.Id)}
                                    >
                                      Hủy
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-md-12" style={{ padding: "0px" }}>
                              <div
                                style={{
                                  height: "1px",
                                  backgroundColor: "#b1b1b1",
                                }}
                              ></div>
                            </div>
                          </div>
                        );
                      })}
                  </InfiniteScroll>
                </div>
              </>
            ) : (
              <div id="divNoDataThongbao" style={{ textAlign: "center" }}>
                <img src={nodata} style={{ width: "150px" }} />
                <br />
                <b style={{ fontSize: "13px", color: "#CCCCCC" }}>
                  Không có dữ liệu
                </b>
              </div>
            )}
          </div>
        )}

        {this.state.isShowHotline && (
          <div class="divThongBaoHotline" ref={this.setWrapperRef}>
            <div className="formHotLine-ver2">
              <div className="nav-item-new text-phone-new">
                <div className="iconHotlinePhone">
                  <img src={phone} alt="" />
                </div>

                <a href="tel:0328666932" alt="" target="_blank">
                  <span>0328 666 932</span>
                </a>
              </div>

              <div className="nav-item-new">
                <a
                  href="https://www.facebook.com/groups/PhanmembanhangNiemTin"
                  alt=""
                  target="_blank"
                >
                  <img src={facebook} alt="" />
                </a>
              </div>
              <div className="nav-item-new">
                <a href="http://zalo.me/0862505355" alt="" target="_blank">
                  <img src={zalo} alt="" />
                </a>
              </div>
            </div>
          </div>
        )}

        {this.state.isShowTicket && (
          <div class="divTicket" ref={this.setWrapperRef}>
            <div className="form-ticket">
              <div className="header-top-ticket">
                <h3>Thông báo Ticket</h3>
              </div>
              <div
                className="form-body-ticket"
                id="scrollableDiv"
                style={{ height: 300, overflow: "auto" }}
              >
                <InfiniteScroll
                  dataLength={this.state.listTicket.length}
                  next={this.onLoadListTicket.bind(this)}
                  hasMore={this.state.pageTicket}
                  loader={
                    <h4 className="text-load">
                      {this.state.listTicket.length ===
                      this.state.TotalRowAllTicket
                        ? "Yay! Bạn đã đọc hết thông báo"
                        : "Đang tải dữ liệu..."}
                    </h4>
                  }
                  // endMessage={
                  //   <h4 style={{ textAlign: "center" }}>
                  //     <b>Yay! You have seen it all</b>
                  //   </h4>
                  // }
                  scrollableTarget="scrollableDiv"
                  // initialLoad={false}

                  // scrollThreshold={0.8}
                >
                  <ul className="list-ticket">
                    {this.state.listTicket &&
                      this.state.listTicket.map((item, index) => {
                        return (
                          <>
                            {item.Status === false ? (
                              <li key={index}>
                                <a
                                  href={() => false}
                                  target="_blank"
                                  onClick={() =>
                                    item.TenTrangThai === "Hoàn thành" &&
                                    item.DanhGia.length < 1
                                      ? this.addDanhGia(item)
                                      : this.addDanhGia2(item)
                                  }
                                >
                                  <i class="mdi mdi-circle-small"></i>
                                  <div className="text-list-ticket">
                                    <span style={{ marginRight: "10px" }}>
                                      Ticket:{" "}
                                    </span>{" "}
                                    {item.TieuDe}{" "}
                                    {item.TenTrangThai === "Hoàn thành"
                                      ? "đã " + item.TenTrangThai
                                      : item.TenTrangThai === "Đang xử lý"
                                        ? item.TenTrangThai
                                        : item.TenTrangThai === "Từ chối"
                                          ? "bị " + item.TenTrangThai
                                          : "đang " + item.TenTrangThai}
                                  </div>
                                </a>
                              </li>
                            ) : (
                              <li key={index}>
                                <a
                                  href={() => false}
                                  target="_blank"
                                  onClick={() =>
                                    item.TenTrangThai === "Hoàn thành" &&
                                    item.DanhGia.length < 1
                                      ? this.addDanhGia(item)
                                      : this.addDanhGia2(item)
                                  }
                                >
                                  <i class="">&nbsp;&nbsp;&nbsp;&nbsp;</i>
                                  <div className="text-list-ticket">
                                    <span style={{ marginRight: "10px" }}>
                                      Ticket:{" "}
                                    </span>{" "}
                                    {item.TieuDe}{" "}
                                    {item.TenTrangThai === "Hoàn thành"
                                      ? "đã " + item.TenTrangThai
                                      : item.TenTrangThai === "Đang xử lý"
                                        ? item.TenTrangThai
                                        : item.TenTrangThai === "Từ chối"
                                          ? "bị " + item.TenTrangThai
                                          : "đang " + item.TenTrangThai}
                                  </div>
                                </a>
                              </li>
                            )}
                          </>
                        );
                      })}
                  </ul>
                </InfiniteScroll>

                {/* <li>
                    <i class="mdi mdi-circle-small"></i>
                    <div className="text-list-ticket">
                      <span>Ticket:</span> không lưu được đơn hàng đã hoàn
                      thànhg đã hoàn thành
                    </div>
                  </li>
                  <li>
                    <i class="">&nbsp;&nbsp;&nbsp;&nbsp;</i>
                    <div className="text-list-ticket">
                      <span>Ticket:</span> không lưu được đơn hàng đã hoàn
                      thànhg đã hoàn thành
                    </div>
                  </li> */}
              </div>
              <div className="form-footer-ticket">
                <a
                  href="#"
                  onClick={() => window.open("/Ticket/DanhSach", "_blank")}
                >
                  {" "}
                  Danh sách Ticket
                </a>
              </div>
            </div>
          </div>
        )}
        {this.state.isModalVisible && (
          <ModalDanhGia toggleModal={this.toggleModal} item={this.state} />
        )}
      </>
    );
  }
}
HeaderNew.propTypes = {
  showBackground: PropTypes.bool,
  isNotBranchTong: PropTypes.bool,
  isBranch: PropTypes.bool,
  isDisable: PropTypes.bool,
  isCheckBranch: PropTypes.bool,
};

export default HeaderNew;
